var _style, _circle, _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#0052B4;}\n\t.st2{fill:#D80027;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M510.5,283.8L510.5,283.8L510.5,283.8L510.5,283.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M510.5,283.8C510.5,283.8,510.5,283.8,510.5,283.8L229.7,1.3c-12.7,1.3-25.1,3.5-37.1,6.6 C81.9,36.1,0,256,0,256s358.4,239.8,399.3,212.2c8.2-5.5,16-11.5,23.5-18L256.4,283.8H510.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M445.2,256L196.2,7C83.7,33.9,0,135.2,0,256c0,141.4,114.6,256,256,256c53.6,0,103.4-16.5,144.5-44.7L189.2,256 H445.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.5,378l-31.3-14.7l16.6-30.3l-33.9,6.5l-4.3-34.3L167,330.4l-23.6-25.2l-4.3,34.3l-33.9-6.5l16.6,30.3 L90.4,378l31.3,14.7L105.1,423l34-6.5l4.3,34.3l23.6-25.2l23.6,25.2l4.3-34.3l33.9,6.5l-16.6-30.3L243.5,378z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.6,142l-22.7-10.7l12.1-22l-24.7,4.7L184.2,89L167,107.4L149.8,89l-3.1,24.9l-24.7-4.7l12.1,22L111.3,142 l55.7,11.1L222.6,142z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.7,142c0,36.9-29.9,66.8-66.8,66.8s-66.8-29.9-66.8-66.8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNp);
export default __webpack_public_path__ + "static/media/np.33fc7f82528a0a723709aac3bd176028.svg";
export { ForwardRef as ReactComponent };